import { Dispatch } from 'redux';

export type FetchFunction = () => void;

export type localStorageItem = string | null;

export type DispatchFunction = (dispatch: Dispatch) => void;

export enum Conjuction {
    and = 'AND',
    or = 'OR',
    then = 'THEN',
    else = 'ELSE'
}

export type ConjuctionType = Conjuction.and | Conjuction.or;

export enum Order {
    asc = 'asc',
    desc = 'desc'
}

export type OrderType = Order.asc | Order.desc;

export interface ICustomSelect {
    id: string;
    name: string;
    organizationId?: string;
    orgName?: string;
}

export interface CommonResponse<V> {
    '@odata.context': string;
    value: V;
}

export type LifeTime = string | number;

export enum SessionStorageTypes {
    aaSid = 'aa_sid',
    correlationId = '_correlation_id_current'
}
